interface PreviewRoot extends HTMLElement {
    _cmsHtmlPreviewInited?: boolean;
}

function activeHtmlSource(root: PreviewRoot): HTMLTextAreaElement | null {
    const sources = Array.from(root.querySelectorAll<HTMLTextAreaElement>('textarea[name*="[value_html]"]'));
    if (sources.length === 0) return null;
    return sources.find((source) => !source.closest(".admin-locale-tabs__panel--hidden")) ?? sources[0] ?? null;
}

function sourceValue(root: PreviewRoot, selector: string): string {
    return root.querySelector<HTMLTextAreaElement>(selector)?.value ?? "";
}

function render(root: PreviewRoot): void {
    const frame = root.querySelector<HTMLIFrameElement>("[data-cms-html-preview-frame]");
    if (!frame) return;

    const html = activeHtmlSource(root)?.value ?? "";
    const css = sourceValue(root, 'textarea[name="html_css"]');
    const js = sourceValue(root, 'textarea[name="html_js"]');
    frame.srcdoc = [
        "<!doctype html>",
        '<html><head><meta charset="utf-8">',
        css !== "" ? `<style>${css}</style>` : "",
        "</head><body>",
        html,
        js !== "" ? `<script>${js}<\/script>` : "",
        "</body></html>",
    ].join("");
}

function mount(root: PreviewRoot): void {
    if (root._cmsHtmlPreviewInited) return;
    root._cmsHtmlPreviewInited = true;

    const schedule = (): void => {
        window.requestAnimationFrame(() => render(root));
    };
    root.addEventListener("input", schedule);
    root.addEventListener("change", schedule);
    root.querySelectorAll("[data-locale-target]").forEach((button) => {
        button.addEventListener("click", schedule);
    });
    schedule();
}

export function initCmsHtmlPreviews(scope: Document | HTMLElement = document): void {
    const roots =
        scope instanceof HTMLElement && scope.matches?.("[data-cms-html-preview]")
            ? [scope as PreviewRoot]
            : Array.from((scope as ParentNode).querySelectorAll<PreviewRoot>("[data-cms-html-preview]"));
    roots.forEach(mount);
}
